import {CrudRightsEnum} from "../enums/user/crud-rights.enum";
import {UserTypeEnum} from "../enums/user/user-type.enum";
import {DtoUserInterface, DtoUserRequestInterface, UserModel} from "../interfaces";

export const mapUserFromDto = (dto: DtoUserInterface): UserModel => {
  const crudRightsString = String(dto.crudRights);
  const crudRights = crudRightsString as CrudRightsEnum;

  return {
    companyId: dto.companyId,
    type: dto.type as UserTypeEnum,
    crudRights: crudRights,
    crudRightsText: dto.crudRightsText || "",
    id: dto.id,
    userId: dto.userId,
    changedBy: dto.changedBy,
    changedTimestamp: dto.changedTimestamp
  };
};

export const mapUserFromDtoArray = (array: Array<DtoUserInterface>): Array<UserModel> => {
  const result: Array<UserModel> = [];

  array.forEach(dto => {
    result.push(mapUserFromDto(dto));
  });

  return result;
};

export const mapUserToDto = (model: UserModel): DtoUserRequestInterface => {
  let companyId: string | null = null;

  if (model.type === UserTypeEnum.All_Assets) {
    companyId = null;
  } else {
    if (model.companyId && model.companyId !== "undefined" && model.companyId !== "null" && model.companyId.trim() !== "") {
      companyId = model.companyId;
    } else {
      companyId = null;
    }
  }

  return {
    companyId: companyId,
    type: model.type as string,
    crudRights: Number(model.crudRights)
  };
};
